export default __webpack_public_path__ + "static/media/applelg.3e544549.svg";